import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Crown, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface UpgradeModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  feature?: string;
}

export const UpgradeModal = ({ open, onOpenChange, feature = "Diese Funktion" }: UpgradeModalProps) => {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center justify-center mb-4">
            <div className="h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center">
              <Crown className="h-8 w-8 text-primary" />
            </div>
          </div>
          <DialogTitle className="text-center text-2xl">
            Upgrade zu Premium
          </DialogTitle>
          <DialogDescription className="text-center text-base">
            {feature} ist nur für Premium- und Pro-Mitglieder verfügbar
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 py-4">
          <div className="flex items-start gap-3">
            <Sparkles className="h-5 w-5 text-primary shrink-0 mt-0.5" />
            <div>
              <p className="font-medium">Unbegrenzte Profile</p>
              <p className="text-sm text-muted-foreground">
                Erstellen Sie Profile für die ganze Familie
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Sparkles className="h-5 w-5 text-primary shrink-0 mt-0.5" />
            <div>
              <p className="font-medium">Individualisierbare QR-Codes</p>
              <p className="text-sm text-muted-foreground">
                Personalisieren Sie Ihre Notfall-QR-Codes
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Sparkles className="h-5 w-5 text-primary shrink-0 mt-0.5" />
            <div>
              <p className="font-medium">Notfall-Benachrichtigungen</p>
              <p className="text-sm text-muted-foreground">
                Erhalten Sie Benachrichtigungen bei QR-Code-Scans
              </p>
            </div>
          </div>
        </div>

        <DialogFooter className="flex-col sm:flex-col gap-2">
          <Button
            onClick={() => {
              onOpenChange(false);
              navigate("/pricing");
            }}
            size="lg"
            className="w-full"
          >
            <Crown className="mr-2 h-4 w-4" />
            Jetzt upgraden
          </Button>
          <Button
            variant="ghost"
            onClick={() => onOpenChange(false)}
            className="w-full"
          >
            Vielleicht später
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
